import script from "./KWorkingHours.vue?vue&type=script&setup=true&lang=js"
export * from "./KWorkingHours.vue?vue&type=script&setup=true&lang=js"

import "./KWorkingHours.vue?vue&type=style&index=0&id=2862a480&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2862a480"]])

export default __exports__